import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex flex-col gap-2" }
const _hoisted_2 = { class: "flex" }
const _hoisted_3 = ["disabled"]

import TextField from "../atoms/TextField.vue";
import { computed, ref } from "vue";
import Selector from "../atoms/Selector.vue";
import {
  InvestimentEnum,
  InvestimentStatusEnum,
  InvestmentRequest,
} from "@/services/invest/types";
import SwitchButton from "../atoms/SwitchButton.vue";
import { upercaseToTitle } from "@/services/utils";

declare type enumType = keyof typeof InvestimentEnum;


export default /*#__PURE__*/_defineComponent({
  __name: 'FormInvestiment',
  emits: ["add"],
  setup(__props, { emit }) {



const investmentType = ref<enumType>("");
const investmentTypes = ref([
  upercaseToTitle(InvestimentEnum[0]),
  upercaseToTitle(InvestimentEnum[1]),
]);
const investmentStatus = ref<enumType>("");
const investmentSt = ref([
  upercaseToTitle(InvestimentStatusEnum[0]),
  upercaseToTitle(InvestimentStatusEnum[1]),
  upercaseToTitle(InvestimentStatusEnum[2]),
]);
const title = ref<InvestmentRequest["title"] | undefined>(undefined);
const description = ref<InvestmentRequest["description"] | undefined>(
  undefined
);
const thumbnail = ref<InvestmentRequest["thumbnail"] | undefined>(undefined);
const value = ref<InvestmentRequest["value"] | undefined>(undefined);
const disableButton = ref<boolean>(false);
const profiability = ref<
  InvestmentRequest["monthlyProfitabilityUf"] | undefined
>(undefined);
const dividendValuesOption = ref<string[]>(["UF", "Pesos Chilenos"]);
const IndexTypeSelected = ref<number>(0);
function handleSubmit() {
  if (
    title.value &&
    description.value &&
    investmentType.value.toUpperCase() &&
    investmentStatus.value.toUpperCase() &&
    thumbnail.value &&
    value.value &&
    profiability.value
  ) {
    const data = new InvestmentRequest(
      undefined,
      title.value,
      description.value,
      investmentType.value,
      investmentStatus.value,
      value.value,
      IndexTypeSelected.value ? undefined : profiability.value,
      IndexTypeSelected.value ? profiability.value : undefined,
      thumbnail.value,
      false
    );
    disableButton.value = true;
    emit("add", data);
  }
}
function getingOptionTypeSelected(newIndexTypeSelected: number) {
  IndexTypeSelected.value = newIndexTypeSelected;
  console.log(
    "obtenemos el valor seleccionado",
    dividendValuesOption.value[IndexTypeSelected.value]
  );
}
// * Error control ---------------------------------------------

function isNullOrEmpty(value?: string | number | null | File): boolean {
  return !value || value == null || value == "" || value == 0;
}

const formHasError = computed(() => {
  const requiredFields = [
    title.value,
    description.value,
    investmentType.value,
    investmentStatus.value,
    thumbnail.value,
    value.value,
    profiability.value,
  ];

  if (requiredFields.some((value) => isNullOrEmpty(value))) {
    return true;
  }

  // Listao de posibles errores del formulario de registro
  const formErrors = [
    titleFieldHasError.value,
    descriptionFieldHasError.value,
    thumbnailFieldHasError.value,
    valueFieldHasError.value,
    investmentTypeFieldHasError.value,
    investmentStatusFielHasError.value,
    profiabilityFieldHasError.value,
    investmentStatusFielHasError.value,
  ];
  if (formErrors.some((hasError) => hasError == true)) {
    return true;
  }

  return false;
});
const titleFieldHasError = computed(() => {
  return isNullOrEmpty(title.value);
});

const descriptionFieldHasError = computed(() => {
  return isNullOrEmpty(description.value);
});
const thumbnailFieldHasError = computed(() => {
  return isNullOrEmpty(thumbnail.value);
});
const valueFieldHasError = computed(() => {
  return isNullOrEmpty(value.value);
});
const investmentTypeFieldHasError = computed(() => {
  return isNullOrEmpty(investmentType.value);
});
const investmentStatusFielHasError = computed(() => {
  return isNullOrEmpty(investmentStatus.value);
});
const profiabilityFieldHasError = computed(() => {
  return isNullOrEmpty(profiability.value);
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(TextField, {
      type: "text",
      name: "Título",
      label: 'Título',
      "hide-details": "",
      model: title.value,
      "onUpdate:model": _cache[0] || (_cache[0] = ($event: any) => ((title).value = $event)),
      hasError: titleFieldHasError.value
    }, null, 8, ["model", "hasError"]),
    _createVNode(TextField, {
      type: "textarea",
      name: "description",
      label: 'Descripción',
      "hide-details": "",
      model: description.value,
      "onUpdate:model": _cache[1] || (_cache[1] = ($event: any) => ((description).value = $event)),
      hasError: descriptionFieldHasError.value
    }, null, 8, ["model", "hasError"]),
    _createVNode(TextField, {
      type: "file",
      name: "thumbnail",
      label: 'Imagen',
      "hide-details": "",
      modelFile: thumbnail.value,
      "onUpdate:modelFile": _cache[2] || (_cache[2] = ($event: any) => ((thumbnail).value = $event)),
      hasError: thumbnailFieldHasError.value
    }, null, 8, ["modelFile", "hasError"]),
    _createVNode(Selector, {
      label: "Tipo de inversión",
      class: "w-full",
      items: investmentTypes.value,
      model: investmentType.value,
      "onUpdate:model": _cache[3] || (_cache[3] = ($event: any) => ((investmentType).value = $event)),
      hasError: investmentTypeFieldHasError.value
    }, null, 8, ["items", "model", "hasError"]),
    _createVNode(Selector, {
      label: "Estado",
      class: "w-full",
      items: investmentSt.value,
      model: investmentStatus.value,
      "onUpdate:model": _cache[4] || (_cache[4] = ($event: any) => ((investmentStatus).value = $event)),
      hasError: investmentStatusFielHasError.value
    }, null, 8, ["items", "model", "hasError"]),
    _createVNode(TextField, {
      type: "number",
      name: "value",
      label: "Valor de compra en UF",
      "hide-details": "",
      model: value.value,
      "onUpdate:model": _cache[5] || (_cache[5] = ($event: any) => ((value).value = $event)),
      hasError: valueFieldHasError.value
    }, null, 8, ["model", "hasError"]),
    _createVNode(SwitchButton, {
      switchOptions: dividendValuesOption.value,
      defaultIndexSelection: IndexTypeSelected.value,
      label: 'Tipo de renta',
      onSwitchTypeSelection: getingOptionTypeSelected
    }, null, 8, ["switchOptions", "defaultIndexSelection"]),
    _createVNode(TextField, {
      type: "number",
      name: "profiability",
      label: 
        IndexTypeSelected.value
          ? 'Renta mensual en pesos chilenos'
          : 'Renta mensual en UF'
      ,
      "hide-details": "",
      model: profiability.value,
      "onUpdate:model": _cache[6] || (_cache[6] = ($event: any) => ((profiability).value = $event)),
      hasError: profiabilityFieldHasError.value
    }, null, 8, ["label", "model", "hasError"]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("button", {
        class: "success btn ml-auto my-2",
        onClick: handleSubmit,
        disabled: formHasError.value || disableButton.value
      }, " Registrar ", 8, _hoisted_3)
    ])
  ]))
}
}

})